import React, { useState } from "react";
// import { ReactComponent as Logo } from "../../../src/assets/images/logo.png";
import  Logo  from "../../../src/assets/images/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MenuOutlined,
} from '@ant-design/icons';
import { Drawer } from "antd";
export const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [drawerVisibility,setDrawerVisibility]=useState(false)
  console.log("location", location.pathname)
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 70,
        padding: "0px 0px",
        width: "100%",
        backgroundColor:"#273975",
      }}
    >
      {/* <Logo /> */}
      <div><img style={{width:75,height:75,cursor:"pointer",marginLeft:40}} onClick={()=>navigate("/")} src={Logo}/></div>
      {window.innerWidth>1000 ? <div style={{ display: "flex", gap: 30, fontSize: 18,fontWeight:400, color: "#000000" }}>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/" ? "#ffffff5c" : "#273975",
            color: location.pathname === "/" ? "white" : "white",
            fontWeight:600,
            borderRadius: 8,
            width: "80px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate("/")}
        >
          Home
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/about_us" ? "#ffffff5c" : "#273975",
            color: location.pathname === "/" ? "white" : "white",
            fontWeight:600,
            borderRadius: 8,
            width: "110px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate("/about_us")}
        >
          About Us
        </div>
        {/* <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/services" ? "#273975" : "#273975",
            borderRadius: 8,
            width: "95px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate("/services")}
        >
          Services
        </div> */}
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/products" ? "#ffffff5c" : "#273975",
            color: location.pathname === "/" ? "white" : "white",
            fontWeight:600,
            borderRadius: 8,
            width: "95px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => navigate("/products")}
        >
          Products
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/contact_us" ? "#ffffff5c" : "#e53535",
            color: location.pathname === "/" ? "white" : "white",
            fontWeight:600,
            borderRadius: 8,
            width: "120px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            marginRight:"50px"
          }}
          onClick={() => navigate("/contact_us")}
        >
          Contact Us!
        </div>
      </div> : <div>
      <MenuOutlined onClick={()=>setDrawerVisibility(true)} style={{backgroundColor:"#ffffff5c" , marginRight:10, color:"#fff", padding:5, height:"20px"}}/>
        </div>}
     
        <Drawer
        closable
        destroyOnClose
        title={<p>Explore More</p>}
        placement="right"
        open={drawerVisibility}
        // style={{width:500}}
        width={window.innerWidth-50}
        onClose={() => setDrawerVisibility(false)}
      >
        <div style={{display:"flex",flexDirection:"column",gap:20,fontSize:20}}>
          <div onClick={()=>navigate("/")}>Home</div>
          <div onClick={() => navigate("/about_us")}>About Us</div>
          {/* <div  onClick={() => navigate("/services")}>Services</div> */}
          <div  onClick={() => navigate("/products")}>Products</div>
          <div   onClick={() => navigate("/contact_us")}>Contact Us</div>
        </div>
      </Drawer>
    </div>
  )
}